<div id="google_translate_element" aria-hidden></div>
<button
    (click)="openGoogleTranslate($event)"
    color="white"
    matTooltip="Select a language"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000">
    Language
    <mat-icon [svgIcon]="'chevron_down'" aria-hidden></mat-icon>
</button>
